import { initSentry } from "./lib/sentry";

// Initialize Sentry FIRST
initSentry();

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
} from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { ApiError } from "./lib/api";
import { AuthProvider } from "./lib/auth";
import { ErrorBoundary } from "./components/ErrorBoundary";
import App from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      // Skip client errors (4xx) - only report server errors (5xx)
      if (error instanceof Error) {
        const msg = error.message.toLowerCase();
        // Skip known client errors (api.ts throws "Unauthorized" for 401, "HTTP 4xx" for others)
        if (
          msg.includes("unauthorized") ||
          msg.includes("forbidden") ||
          msg.includes("not found") ||
          msg.includes("http 4")
        ) {
          return;
        }
        // Skip upstream proxy errors (502 Bad Gateway, 504 Gateway Timeout)
        // These indicate issues in upstream services, not in this application
        if (
          error instanceof ApiError &&
          (error.status === 502 || error.status === 504)
        ) {
          return;
        }
        Sentry.captureException(error);
      }
    },
  }),
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
